import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { UserMenuOption } from '../interfaces/user-menu-option.interface';
import { AngularUser } from 'Angular/interfaces/angular-user.interface';

import { CookieService } from 'ngx-cookie-service';

/**
 *
 * UserMenu Component
 *
 */

@Component({ standalone: false, selector: 'ycn-user-menu', templateUrl: './user-menu.template.html' })
export class UserMenuComponent implements OnInit {
    @Input() userMenuActive: boolean = false;

    @Output() addErrorMessageHandler: EventEmitter<string> = new EventEmitter<string>();

    USER: AngularUser = window.USER;

    menuOptions: UserMenuOption[] = [];

    csrfToken: string = '';

    constructor(private cookieService: CookieService) {}

    ngOnInit(): void {
        this.csrfToken = this.cookieService.get('csrftoken');

        const nextLogoutLink = `/logout?next=${window.location.pathname}`;
        const nextLoginLink = `/login?next=${window.location.pathname}`;

        const authenticatedOptions: UserMenuOption[] = [
            {
                title: 'Account Settings',
                href: '/accounts/account_settings/profile',
                dataTestId: 'user-menu-account-settings',
            },
            {
                title: 'Go to Admin',
                href: '/admin/',
                includeCondition: () => this.USER.isStaff,
            },
            {
                title: 'Return to Admin User',
                href: '/accounts/return_to_admin_user',
                includeCondition: () => this.USER.impersonationState.adminImpersonating,
            },
            {
                title: 'Sign Out',
                href: nextLogoutLink,
                dataTestId: 'user-menu-sign-out',
            },
        ];

        const unauthenticatedOptions: UserMenuOption[] = [
            {
                title: 'Free Trial',
                href: '/start_trial',
            },
            {
                title: 'Sign In',
                href: nextLoginLink,
                dataTestId: 'user-menu-sign-in',
            },
        ];

        if (this.USER.authenticated) {
            authenticatedOptions.forEach((option) => {
                if (!option.includeCondition || option.includeCondition()) {
                    this.menuOptions.push(option);
                }
            });
        } else {
            unauthenticatedOptions.forEach((option) => this.menuOptions.push(option));
        }
    }
}
